module.exports = new __parcel__URL__("hippo.81684e99.svg").toString();